export const SET_ALL = 'SET_ALL';
export const SET_STEP_MODEL = 'SET_STEP_MODEL';
export const SET_INVESTMENT_LIST_ITEM_STATUS = 'SET_INVESTMENT_LIST_ITEM_STATUS';
export const SET_INVESTMENT_LIST_ITEM_TAX_AS_READ = 'SET_INVESTMENT_LIST_ITEM_TAX_AS_READ';
export const SET_UPDATES_DOCUMENT_AS_READ = 'SET_UPDATES_DOCUMENT_AS_READ';
export const UPDATE_INVESTMENT_DATA_BY_ID = 'UPDATE_INVESTMENT_DATA_BY_ID';
export const SET_FINANCIAL_STATEMENTS_AS_READ = 'SET_FINANCIAL_STATEMENTS_AS_READ';
export const REMOVE_UPDATES_DOCUMENT = 'REMOVE_UPDATES_DOCUMENT';
export const REMOVE_TAX_DOCUMENT = 'REMOVE_TAX_DOCUMENT';
